<template>
  <div class="XVsticky-container">
    <div :style="{ width: stickyDivWidth, top: fixedContainerHeight }" :class="getStickyClass" class="stickybar">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: function() {
    return {
      makeSticky: false,
      stickyDivWidth: 0
    }
  },
  computed: {
    getStickyClass() {
      let stickyc = this.makeSticky ? 'stickyfixed' : ''
      return this.StickyClass + ' ' + stickyc
    },
    ...mapGetters(['fixedContainerHeight'])
  },
  methods: {
    handleScroll() {
      this.stickyDivWidth = $('#contentdiv').width() + 'px'
      var scrollTop = $(window).scrollTop()
      if (this.stickyHeight === 0 && scrollTop > 50) {
        // PE-18722 - scroll probleem verschillende pagina's.
        // als de sticky bar fixed wordt met scrollen en de pagina net iets groter is dan het scherm, dan schudt het scherm en zijn sommige items,
        // bijv het laatste bericht op de berichtenpagina niet leesbaar of aan te klikken.
        // de aanpassing is dat er in dit schenario nu een padding-bottom te staan in dit scenario.
        if ($('#contentdiv').height() <= $(window).height() + 50) {
          let ContentDivPadding = $(window).height() - $('#contentdiv').height() + 50
          $('#contentdiv').css('padding-bottom', ContentDivPadding)
        }
        this.makeSticky = true
        // agenda vue: property stickyheight toegevoegd. in het geval van de agenda zit er nog een stuk tekst boven de xvsticky en tabel waardoor
        // als je scrollt, de xvsticky te snel sticky wordt en je in dit geval eerst nog tekst krijgt tussen bijv de header table en inhoud table.
      } else if (this.stickyHeight > 0 && scrollTop > this.stickyHeight) {
        if ($('#contentdiv').height() <= $(window).height() + this.stickyHeight) {
          let ContentDivPadding = $(window).height() - $('#contentdiv').height() + this.stickyHeight
          $('#contentdiv').css('padding-bottom', ContentDivPadding)
        }
        this.makeSticky = true
      } else {
        this.makeSticky = false
        $('#contentdiv').css('padding-bottom', 0)
      }
    }
  },
  props: {
    StickyClass: {
      default: 'bckcol-primary'
    },
    stickyHeight: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.stickyDivWidth = $('#contentdiv').width() + 'px'
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
  }
}
</script>

<style>
.stickyfixed {
  position: fixed;
  z-index: 20;
  /* padding-right: 24px; */
}
.XVsticky-container {
  margin-top: -15px;
}
</style>
